import { t } from '@lingui/core/macro'

export const StepsFileInfo = () => (
  <div className="mt-10">
    <p className="text-slate-800 font-medium text-xs">{t`Tips for .csv upload format:`}</p>
    <ul className="list-disc list-outside text-slate-800 text-xs pl-5">
      <li>
        {t`Include only the taxonomy name and its corresponding field names — no campaign data or other metadata should be included.`}
      </li>
      <li>
        {t`Each taxonomy should start on its own row, clearly labeled (e.g., DV360, Facebook, Twitter).`}
      </li>
      <li>
        {t`Field names should be listed in the same row as the taxonomy, in adjacent columns to the right.`}
      </li>
      <li>
        {t`Do not include sample values, formatting notes, or merged cells — only plain text field names.`}
      </li>
      <li>
        {t`Save the sheet as a .csv file with no additional headers, formulas, or descriptive text outside the field definitions.`}
      </li>
    </ul>
  </div>
)
